var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mb-2 grey lighten-4"},[_c('v-card-text',{staticClass:"headline font-weight-bold",attrs:{"justify":"center","align":"center"}},[_c('div',{staticStyle:{"height":"60vh"},attrs:{"id":"livechat"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }